import EtherAmount from './EtherAmount';
import EthIcon from './EthIcon';
import Logo from './Logo';
import Panel from './Panel';
import React from 'react';
import useWalletAssets from '../hooks/useWalletAssets';
import WalletPopup from './WalletPopup';
import { FaWallet } from 'react-icons/fa';
import { getShortenedAddress } from '../utils/walletUtils';
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';
import {
  Box,
  Button,
  Container,
  HStack,
  Icon,
  Text,
  useBoolean,
} from '@chakra-ui/react';

const Header: React.FC = () => {
  const { address } = useAccount();
  const { balance } = useWalletAssets();
  const [isWalletDialogOpen, setIsWalletDialogOpen] = useBoolean();

  return (
    <>
      <Panel as="header" px="0" py="4" borderRadius="0">
        <Container>
          <HStack overflow="hidden" spacing="4">
            <Link to="/">
              <Logo w="8em" />
            </Link>

            <HStack justify="flex-end" w="full" spacing="3">
              <Box bg="dark.700" lineHeight="10" px="3" borderRadius="full">
                <HStack w="full" spacing="1">
                  <Icon as={EthIcon} w="4" h="4" color="primary.500" />
                  <Text>
                    <EtherAmount amount={balance} />
                  </Text>
                </HStack>
              </Box>

              {address && (
                <Button
                  flex="none"
                  color="bright.50"
                  borderColor="dark.500"
                  _hover={{
                    borderColor: 'primary.500',
                  }}
                  colorScheme="bright"
                  borderRadius="full"
                  variant="outline"
                  size="sm"
                  leftIcon={<Icon as={FaWallet} color="primary.500" />}
                  onClick={setIsWalletDialogOpen.on}
                >
                  {getShortenedAddress(address, 3)}
                </Button>
              )}
            </HStack>
          </HStack>
        </Container>
      </Panel>

      {isWalletDialogOpen && (
        <WalletPopup isOpen onClose={setIsWalletDialogOpen.off} />
      )}
    </>
  );
};

export default Header;
